import axios from "axios";

export const LOGIN_URL = `${process.env.REACT_APP_API_URL}/auth/login`;
export const LOGIN_VERIFY_URL = `${process.env.REACT_APP_API_URL}/auth/verify`;
export const REGISTER_URL = "api/auth/register";
export const REQUEST_PASSWORD_URL = "api/auth/forgot-password";
export const ME_URL = `${process.env.REACT_APP_API_URL}/auth/me`;
export const WALLETS_URL = `${process.env.REACT_APP_API_URL}/auth/wallets`;
export const CHARGE_WALLET_URL = `${process.env.REACT_APP_API_URL}/auth/wallets/charge`;

export function login(phone, password) {
    return axios.post(LOGIN_URL, {phone, password});
}

export function loginVerify(code){
    return axios.post(LOGIN_VERIFY_URL, {code});
}

export function register(email, fullname, username, password) {
    return axios.post(REGISTER_URL, {email, fullname, username, password});
}

export function requestPassword(email) {
    return axios.post(REQUEST_PASSWORD_URL, {email});
}

export function getUserByToken() {
    // Authorization head should be fulfilled in interceptor.
    return axios.get(ME_URL);
}

export function getWallets(){
    return axios.get(WALLETS_URL);
}

export function chargeWallet(data){
    return axios.post(CHARGE_WALLET_URL, data);
}